///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.index = abcsetup.promos.index || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.index = {
    promo_id: null,
    init: function() {
        abcsetup.setTitle('Promotions');

        var promo = JSON.parse($("#item_object").val());
        abcsetup.promos.index.promo_id = promo['id'];

        // Load datatable.
        $(function () {
            abcsetup.promos.index.load();
        });

        $(document).on('click','#reject_approved_promo', function () {
            let numberOfRejected = $('input.reject_approved_promo:checked').length;
            let numberOfApproved = $('input.approve_promo:checked').length;
            let hasErrors = false;
            if (numberOfApproved) {
                $('input.approve_promo:checked').each(function () {
                    let month = $(this).closest("tr").find(".assigned_approval_month").find('select').val();
                    if (month == '') {
                        hasErrors = true
                        $(this).closest("tr").find(".assigned_approval_month").find('div.alert').show();
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(this).offset().top
                        }, 1000);
                        return false;
                    }
                });

                if(hasErrors)
                    return false;
            }
            if (numberOfRejected || numberOfApproved) {
                var fields = $('form#promotion_item').serialize();
                axios.post('/api/promos/reject_approved_promo',fields).then( response => {
                    if(response.data.error) {
                        abcsetup.alerts.show('Error', response.data.error);
                    } else {
                        abcsetup.promos.index.load();
                        if (numberOfRejected) {
                            $(".promo_item_reject_approved.alert").show();
                            setTimeout(function() {
                                $(".promo_item_reject_approved.alert").hide();
                            }, 3000);
                        }
                        if (numberOfApproved) {
                            $(".promo_item_approved.alert").show();
                            setTimeout(function() {
                                $(".promo_item_approved.alert").hide();
                            }, 3000);
                        }
                    }
                });
            }
        });
    },
    load: function () {
        abcsetup.dashboard.showLoading($('#promos'));
        var promo_id = abcsetup.promos.index.promo_id

        if(promo_id) {
            axios.get('/api/promo/promosattr/'+promo_id).then(response => {
                if (response.data.table_data) {
                    $('#promos').find('#promotions table, #promotions .dataTables_wrapper').remove();
                    $('#promos').find('#promotions').append(response.data.table_data);
                    $('#promos').find('#promotions').find('#' + response.data.table_id).addClass('table-sm');

                    // Apply custom classes
                    $('#promos').find('#promotions').find('#' + response.data.table_id + ' tbody tr').each(function () {
                        $(this).addClass($(this).find('td:first').html());
                    });

                    // Init datatables
                    abcsetup.datatables.init($('#promos').find('#promotions').find('#' + response.data.table_id), {
                        "remove": [0,1], // Remove class column
                        bInfo: true,
                        "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
                        "iDisplayLength": 5,
                        // "order": [[3, "desc"]],
                        "responsive": true,
                        'columnDefs': [
                            {
                                'targets': 3,
                                'render': function(data, type, row, meta) {
                                   if(type === 'display' &&  data == 'promo_team_waitlisted') {
                                     data =  '<div class="approve_item">'+
                                                 '<div class="approved_promo_checkbox">'+
                                                     '<input type="checkbox" value="promo_team_approved" name="promos['+row[1]+'][item_status]" class="approve_promo dt-checkboxes">'+
                                                 '</div>'+
                                                     //'<label></label>'+
                                                 '<div class="approve_item_reason hide">'+
                                                 'FOO'+
                                                 '</div>'+
                                             '</div>';
                                   } else {
                                     data =  '<div class="checkbox"><input type="checkbox" name="promos['+row[1]+'][item_status]"  disabled class="checkbox dt-checkboxes"><label></label></div>';
                                   }
                                   return data;
                                },
                               'checkboxes': {
                                  'selectRow': true,
                                  'selectAllRender': '<div class="checkbox"><input type="checkbox" class="dt-checkboxes"><label></label></div>'
                               }
                            },
                            {
                               'targets': 2,
                               'render': function(data, type, row, meta) {
                                  if(type === 'display' &&  data == 'promo_team_approved') {
                                    data =  '<div class="reject_approve_item">'+
                                                '<div class="reject_approved_promo_checkbox">'+
                                                    '<input type="checkbox" value="promo_team_rejected" name="promos['+row[1]+'][item_status]" class="reject_approved_promo dt-checkboxes">'+
                                                '</div>'+
                                                    //'<label></label>'+
                                                '<div class="reject_approve_item_reason" style="display:none">'+
                                                    '<h6>Reject reason</h6>'+
                                                    '<textarea title="Add reason selected item was rejected for Promotion" name="promos['+row[1]+'][promo_admin_review_message]" rows="4" cols="30"></textarea>'+
                                                '</div>'+
                                            '</div>';
                                  } else if(type === 'display' &&  data == 'promo_team_waitlisted') {
                                    data =  '<div class="reject_approve_item">'+
                                                '<div class="reject_approved_promo_checkbox">'+
                                                    '<input type="checkbox" value="promo_team_rejected" name="promos['+row[1]+'][item_status]" class="reject_approved_promo dt-checkboxes">'+
                                                '</div>'+
                                                    //'<label></label>'+
                                                '<div class="reject_approve_item_reason" style="display:none">'+
                                                    '<h6>Reject reason</h6>'+
                                                    '<textarea title="Add reason selected item was rejected for Promotion" name="promos['+row[1]+'][promo_admin_review_message]" rows="4" cols="30"></textarea>'+
                                                '</div>'+
                                            '</div>';
                                  }
                                  else {
                                    data =  '<div class="checkbox"><input type="checkbox" name="promos['+row[1]+'][item_status]"  disabled class="checkbox dt-checkboxes"><label></label></div>';
                                  }
                                  return data;
                               },
                               'checkboxes': {
                                  'selectRow': true,
                                  'selectAllRender': '<div class="checkbox"><input type="checkbox" class="dt-checkboxes"><label></label></div>'
                               }
                            },
                            {
                                "targets": 1,
                                "orderable": false
                            },
                            // {
                            //     "targets": '_all',
                            //     "searchable": false
                            // },
                         ],
                         'select': {
                            'style': 'multi',
                             'selector' : 'td:first-child'
                         },
                    });

                }

                abcsetup.dashboard.removeLoading($('#promos'));

            }).catch(error => {
                abcsetup.dashboard.removeLoading($('#promos'));
            });
        }

        $(document).off('click','input.reject_approved_promo');
        $(document).on('click','input.reject_approved_promo', function () {
            let isChecked = $(this).is(":checked");
            if (isChecked) {
                $('input.approve_promo[name="'+$(this).attr('name')+'"]').attr('disabled',true);
            }
            else {
                $('input.approve_promo[name="'+$(this).attr('name')+'"]').attr('disabled',false);
            }
            $(this).closest(".reject_approve_item").find(".reject_approve_item_reason").toggle();
        });
        $(document).off('click','input.approve_promo');
        $(document).on('click','input.approve_promo', function () {
            let isChecked = $(this).is(":checked");
            if (isChecked) {
                $('input.reject_approved_promo[name="'+$(this).attr('name')+'"]').attr('disabled',true);
            }
            else {
                $('input.reject_approved_promo[name="'+$(this).attr('name')+'"]').attr('disabled',false);
            }
            $(this).closest("tr").find(".assigned_approval_month").toggle();
        });
    },
}